import { useInit } from '../api/ws';
import { AnimationLayout, Button, Footer, Header, LoaderScreen } from '../components';
import { useGlobalForm } from '../contexts/global-form-context';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useQueryClient } from '@workspace/api';
import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';

export default function FormLayout() {
  const { initialState, actions, origin, config } = useGlobalForm();
  const query = useInit({
    // token: getCookie('devis_token'),
    token: localStorage.getItem('devis_token') as string,
    origin: origin || 'site',
  });
  const queryClient = useQueryClient();
  const hasInitializedRef = useRef(false);

  useEffect(() => {
    // g.actions.updateStep(0);
    if (query.isSuccess && !hasInitializedRef.current) {
      hasInitializedRef.current = true;
      // const tokenCookie = getCookie('devis_token');
      const tokenCookie = localStorage.getItem('devis_token') as string;
      if (!tokenCookie) {
        queryClient.setQueryData(['init', { key: undefined, origin: origin || 'site', token: query.data.token }], query.data);
      }

      actions.saveInitialData(query.data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess]);

  if ((query.isLoading || initialState === null) && !query.isError) {
    return <LoaderScreen className="h-screen" />;
  }

  if (query.isError) {
    // @ts-expect-error response.data is not typed on the error object
    const error = query.error?.response?.data;

    if (error?.code === 498) {
      return <ExpiredBlock />;
    }

    const customErrorBlock = error?.code !== undefined ? config?.initErrors?.[error.code] : undefined;
    if (customErrorBlock) {
      return <>{customErrorBlock}</>;
    }

    return <ErrorBlock />;
  }

  // TODO : move it app-form, for evite circular dependency

  return (
    <>
      <Header />
      <AnimationLayout>
        <Outlet />
      </AnimationLayout>
      <Footer />
    </>
  );
}

const ErrorBlock = () => {
  return (
    <div className="h-screen flex flex-col items-center justify-center">
      <ExclamationTriangleIcon
        className="w-16 h-16 text-red-500"
        strokeWidth={1}
      />
      <h1 className="text-2xl font-semibold">Erreur de chargement</h1>
      <p className="text-center text-sm text-gray-500 mt-2">Impossible de charger le formulaire, veuillez réessayer.</p>
      <p className="text-center text-sm text-gray-500">Si le problème persiste, veuillez contacter le support.</p>

      <Button
        variant="secondary"
        onClick={() => window.location.reload()}
        className="mt-4"
        size="sm"
        arrow={false}
      >
        Recharger la page
      </Button>
    </div>
  );
};

const ExpiredBlock = () => {
  const handleReload = () => {
    localStorage.removeItem('devis_token');
    window.location.reload();
  };

  return (
    <div className="h-screen flex flex-col items-center justify-center">
      <ExclamationTriangleIcon
        className="w-16 h-16 text-red-500"
        strokeWidth={1}
      />
      <h1 className="text-2xl font-semibold text-primary">Session expirée</h1>
      <p className="text-center text-sm text-gray-500 mt-2">Votre session a expiré, veuillez vous reconnecter.</p>
      <Button
        onClick={handleReload}
        className="mt-4"
        size="sm"
        arrow={false}
      >
        Recommencer
      </Button>
    </div>
  );
};
